<button type="button" class="btn btn-icon btn-danger" (click)="confirm()" [disabled]="disabled">
  <icon-trash-alt class="ml-n1" [style.width.px]="10" [style.height.px]="12"></icon-trash-alt>
  <span class="ml-2">Delete {{ type }}</span>
</button>
